import Breadcrumb, { type Crumb } from '@/components/base/Breadcrumb';

type PageHeadingProps = {
  crumbs: Crumb[];
  eyebrow: string;
  title: string;
  description: string;
  count?: string;
};

export default function PageHeading({ crumbs, eyebrow, title, description, count }: PageHeadingProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-8 md:px-8 md:py-12">
        <Breadcrumb items={crumbs} />
        <div className="mt-6 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs tracking-[0.24em] text-primary-600">
              <span className="h-[1px] w-6 bg-primary-400" />
              {eyebrow}
            </p>
            <h1 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">{title}</h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{description}</p>
          </div>
          {count && (
            <div className="shrink-0 border-l-2 border-accent-500 pl-4">
              <p className="font-heading text-2xl text-foreground-900">{count.split(' ')[0]}</p>
              <p className="mt-1 text-xs tracking-wide text-foreground-500">{count.split(' ').slice(1).join(' ')}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}